module.exports = __webpack_public_path__ + "img/home-policy.d45b231c.png";